<template>
    <div>
        <Header />
        <v-container class="d-flex justify-center align-center fill-height">
      <v-card class="text-center pa-1" >
  <v-card-text>
        <v-row>
          <v-col cols="12" style="padding: 0px 70px 0px 70px;">
            <v-img
              :src="require('@/assets/images/barcode-scan.gif')"
              max-height="280" style="width: 100%;"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-on:keyup.enter="scan"
              v-model="scannedbarcode"
              label="Barcode"
              outlined
              ref="scanbar"
            ></v-text-field>
          </v-col>
        </v-row>
        </v-card-text>
        </v-card>
      </v-container>
    </div>
  </template>
  <script>
  import Header from "../Pages/Header.vue";
  export default {
    components: {
      Header
    },
    data() {
      return {
        scannedbarcode: "",
        outputValueOnEnter: ""
      };
    },
    mounted() {
      this.Token = localStorage.getItem('Token')
      if (this.Token === "" || this.Token === null || this.Token === undefined ) 
       {
        this.$router.push("login");
       }
      this.$refs.scanbar.focus();
    },
    methods: {
      scan(e) {
        localStorage.setItem("barcode", e.target.value);
         this.$router.push("/BarcodeResult");
      },
      
    }
  };
  </script>
  